module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm3_m_en.5ca70f6faf6be0fbfba5af2f953830e4.png";